import { fetchPublicEvents } from 'utils/queries'

import { Event } from 'types/event'

import { useInfiniteQuery } from './useInfiniteQuery'

export const usePublicEvents = ({ limit = 50 }: { limit?: number }) => {
  return useInfiniteQuery<Array<Event>>(
    ['publicEvents'],
    ({ pageParam }) =>
      fetchPublicEvents({
        order: 'created',
        orderDirection: 'desc',
        lastVisible: pageParam,
        limit,
      }),
    {
      refetchOnMount: 'always',
      getNextPageParam: (lastPage) => {
        // Very important, as the last page might not have any results
        if (!lastPage || !lastPage.length) return undefined

        return lastPage[lastPage.length - 1].created
      },
    },
  )
}
